import { bindActionCreators } from "redux";
import {
  deleteAction,
  getTechnologies,
  submitGeneralForm,
  systemLogin,
  fetchDetails,
  putAction, getLoggedUser, setSelectedMenu, downloadExcelFile,
  getAllMenus,
  getUserPermissions,
  getMyStructure,
  getWholeStructure,
} from "../User/action";
import {
  createMeeting,
  getAllMeetings,
  updateMeeting,
  getAllInvitedIn,
  getMinutesTemplate,
  createMinutes,
  getAvailableRooms,
  downloadDocument,
  shareMinutes,
  getRooms,
  getMeeting,
  createRoom,
  downloadDocumentById,
  generalDownload,
  downloadBase64,
  getAllResources,
  getAllMeetingList,
  createDraft,
  getMinutesDetails,
} from "../Meeting/actions";

import { viewAllQualification, viewOneQualification } from "../Qualification/action"

import { projectViewAll } from "../Project/actions"

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      SystemLogin: systemLogin,
      SubmitGeneralForm: submitGeneralForm,
      GetLoggedUser: getLoggedUser,
      SetSelectedMenu: setSelectedMenu,
      DeleteAction: deleteAction,
      PutAction: putAction,
      FetchDetails: fetchDetails,
      GetTechnologies: getTechnologies,
      DownloadExcelFile: downloadExcelFile,

      //Meeting
      ScheduleMeeting: createMeeting,
      CreateRoom: createRoom,
      GetAllMeetings: getAllMeetings,
      UpdateMeeting: updateMeeting,
      GetAllInvitedIn: getAllInvitedIn,
      GetAvailableRooms: getAvailableRooms,
      GetRooms: getRooms,
      DownloadDocument: downloadDocument,
      GeneralDownload: generalDownload,
      DownloadBase64: downloadBase64,
      DownloadDocumentById: downloadDocumentById,
      MeetingDetails: getMeeting,
      GetAllResources: getAllResources,
      GetAllMeetingList: getAllMeetingList,
      CreateDraft: createDraft,
      // minutes
      GetMinutesTemplate: getMinutesTemplate,
      CreateMinutes: createMinutes,
      ShareMinutes: shareMinutes,
      GetMinutesDetails: getMinutesDetails,

      // project
      ListAllProjects: projectViewAll,

      // qualification
      ViewAllQualification: viewAllQualification,
      ViewOneQualification: viewOneQualification,

      //permission
      GetAllMenus: getAllMenus,
      GetUserPermissions: getUserPermissions,
      GetMyStructure: getMyStructure,
      GetWholeStructure: getWholeStructure


    },
    dispatch
  );
};
